export default {
  products: {
    free: null,
    grow: 'prod_J0QCa1wYgzSELM',
    pro: 'prod_HGX1QGKHyjHtwn',
    'app-sumo-pro': 'prod_JoHwpxbK2u5nt9',
    business: 'prod_G7P0IcFipSL9uv',
    premium: 'prod_G7P2LYXno291xy',
    'base-premium': 'prod_I6jYfKt14LM42z'
  },
  plans: {
    // old plans
    free: null,
    // 'researcher-monthly': 'plan_HGX3S6LBDO5zd8',
    // 'researcher-annual': 'plan_HGvhTiOvMz5PqW',
    // 'pro-monthly': 'plan_G7P1vlKdUgI6bV',
    // 'pro-annual': 'plan_HGviivS9K5K4iL',
    // 'business-monthly': 'plan_G7P2lxyJ9pPjPl',

    /** Renamed old admin's trial plans */
    'pro-admin-trial': 'price_HK0grLtodFJThB',
    'business-admin-trial': 'price_HK0h8RTZB0rn31',
    'premium-admin-trial': 'price_HJwD3ElEpBhcjV',

    /* New plans **/

    // 0. Grow
    'grow-monthly': 'price_1IOPLoJ1GI5FYk3yIJVwAeh0',
    'grow-annual': 'price_1IOPLoJ1GI5FYk3yUmO7a6gY',
    // 0.1 Grow GBP
    'grow-monthly-gbp': 'price_1IOQDHJ1GI5FYk3y2KL1PXIJ',
    'grow-annual-gbp': 'price_1IOQE4J1GI5FYk3yl2KJO71Y',

    // 1. Pro
    'pro-monthly': 'price_1HFbWOJ1GI5FYk3yYqzWbUUV',
    'pro-annual': 'price_1HFbWvJ1GI5FYk3yMFs5BonZ',
    // 1.1 Pro GBP
    'pro-monthly-gbp': 'price_1HFbY1J1GI5FYk3y7QMaQkb7',
    'pro-annual-gbp': 'price_1HFbZ7J1GI5FYk3yutju58mG',

    // 1.2 Pro App Sumo
    'app-sumo-pro-annual': 'app-sumo-plan',

    // 1.3 CartLoop Plan
    'cartloop-pro-monthly': 'cartloop-plan',

    // 2. Business
    'business-monthly': 'price_1HCLhYJ1GI5FYk3y7GIWjh6Y',
    'business-annual': 'price_1HCLi7J1GI5FYk3ykZV22CZf',
    // 2.1 Business GBP
    'business-monthly-gbp': 'price_1HCOsPJ1GI5FYk3yi8Viocsq',
    'business-annual-gbp': 'price_1HCOtBJ1GI5FYk3ySSwVLd9D',

    // 3. Enterprise Base Premium
    'base-premium-monthly-gbp': 'price_1HWW5ZJ1GI5FYk3yeTlHnToy'
  }
}
